import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { OrdersService } from '../../services/orders/orders.service';
import { appService } from '../../../_services/app.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { Router } from '@angular/router';
import { Helpers } from '../../../helpers';


@Component({
  selector: 'app-new-edit-selected-bulk-order',
  templateUrl: './new-edit-selected-bulk-order.component.html',
  styleUrls: ['./new-edit-selected-bulk-order.component.scss']
})
export class NewEditSelectedBulkOrderComponent implements OnInit, OnChanges {

  @Output() onCloseBtnClick = new EventEmitter<any>();
  // @Input() BookingId:any;
  userId:any;
  CompanyId: any;
  SelectedCompanyGSTCode: any;
  TenantId: any;
  @Output() OnRefreshParent = new EventEmitter<string>();
  @Output() sendDataToParent = new EventEmitter<any>();
  @Input() data: any = {};
  isFormSubmitY: boolean = false;

   TransportService: any = {
    lable: 'Transport Service',
    formControlName: 'transportService',
    dataField: 'transportService',
    isRequired: true,
    placeholder: 'Select Transport Service',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  Customer: any = {
    lable: 'Customer',
    formControlName: 'customer',
    dataField: 'customer',
    isRequired: true,
    placeholder: 'Select Customer',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  VehicleType: any = {
    lable: 'Vehicle Type',
    formControlName: 'size',
    dataField: 'size',
    isRequired: true,
    placeholder: 'Select Vehicle Type',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  PickupLocation: any = {
    lable: 'Origin',
    formControlName: 'origin',
    dataField: 'origin',
    isRequired: true,
    placeholder: 'Select Origin',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  DeliveryLocation: any = {
    lable: 'Destination',
    formControlName: 'destination',
    dataField: 'destination',
    isRequired: true,
    placeholder: 'Select Destination',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  VehicleNo: any = {
    lable: 'Vehicle No',
    formControlName: 'truckNumber',
    dataField: 'truckNumber',
    isRequired: true,
    placeholder: 'Select Vehicle No',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };

  ContainerNo: any = {
    lable: 'Container No',
    formControlName: 'containerNumber',
    dataField: 'containerNumber',
    isRequired: false,
    placeholder: 'Enter Container No',
  };

  SealNo: any = {
    lable: 'Seal No',
    formControlName: 'sealNumbers',
    dataField: 'sealNumbers',
    isRequired: false,
    placeholder: 'Enter Seal No',
  };

  Scan: any = {
    lable: 'Scan',
    formControlName: 'scanLines',
    dataField: 'scanLines',
    isRequired: false,
    placeholder: 'Enter Scan',
  };

  TripDate: any = {
    lable: 'Trip Date',
    formControlName: 'tripDate',
    dataField: 'tripDate',
    isRequired: true,
    placeholder: 'Select Trip Date',
  };

  DieselTaken: any = {
    lable: 'Diesel Taken',
    formControlName: 'dieselTaken',
    dataField: 'dieselTaken',
    isRequired: false,
    placeholder: 'Enter Diesel Taken',
    type: "number",
  };

  Weight: any = {
    lable: 'Weight(Kgs)',
    formControlName: 'weight',
    dataField: 'weight',
    isRequired: false,
    placeholder: 'Enter Weight',
    type: "number",
  };

  Driver: any = {
    lable: 'Driver',
    formControlName: 'Driver',
    dataField: 'Driver',
    isRequired: false,
    placeholder: 'Select Driver',
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true
  };   
  
  constructor(
    private orderService: OrdersService,
    private _appService: appService,
    private toastr: ToastrService,
    private cookieService: CookieService,
    private decryptpipe: DecryptPipe,
    private router: Router
  ) { }

  ngOnInit() {
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.SelectedCompanyGSTCode = JSON.parse(localStorage.getItem("ChnageCompnayId")).GSTCode;
    this.TenantId = JSON.parse(
      this.decryptpipe.transform(JSON.parse(this.cookieService.get("TenantId")))
    );
    // this.data[this.ContainerNo.dataField]=this.data.containerNumber;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['data'] && changes['data'].currentValue) {
      this.mapData();
    }
  }

  mapData() {
    this.data[this.ContainerNo.dataField] = this.data.containerNumber;
    this.data[this.SealNo.dataField] = this.data.sealNumbers;
    this.data[this.Scan.dataField] = this.data.scanLines;
    this.data[this.TripDate.dataField] = this.data.tripDate;
    this.data[this.Customer.dataField] = this.data.customer;
    this.data[this.PickupLocation.dataField] = this.data.origin;
    this.data[this.DeliveryLocation.dataField] = this.data.destination;
    this.data[this.VehicleNo.dataField] = this.data.truckNumber;
    this.data[this.VehicleType.dataField] = this.data.size;
    this.data[this.TransportService.dataField] = this.data.transportService;
    this.data[this.Weight.dataField] = this.data.weight;
    this.data[this.DieselTaken.dataField] = this.data.dieselTaken;
    this.data[this.Driver.dataField] = this.data.driverId;
    
    this.data.SRNo = this.data.SRNo;
    this.data.customerName = this.data.customer;
    this.data.VehicleNoText = this.data.truckNumber;
    this.data.sizeName = this.data.size;
    this.data.transportServiceName = this.data.transportService;
    this.data.driverName = this.data.driverName;
    this.data.driverId = this.data.driverId;

    this.setDropdown(this.Customer,this.data.customer,this.data.customer);
    this.setDropdown(this.PickupLocation,this.data.origin,this.data.origin);
    this.setDropdown(this.DeliveryLocation,this.data.destination,this.data.destination);
    this.setDropdown(this.VehicleNo,this.data.truckNumber,this.data.truckNumber);
    this.setDropdown(this.VehicleType,this.data.size,this.data.size);
    this.setDropdown(this.TransportService,this.data.transportService,this.data.transportService);
    this.setDropdown(this.Driver,this.data.driverId,this.data.driverName);
  }

  setDropdown(control: any, value: any, name: any) {
    control.dropdownList = [{
      value,
      name
    }];
  }

  // GetTransportService() {
  //   this.orderService.GetSelect2TransportServiceData().then(
  //   (res) => {
  //     this.TransportService.dropdownList = [];
  //     this.TransportService.dropdownList = res;
  //   })
  //   .catch((error) => {
  //     console.log(error);
  //   });
  // }

  GetTransportService(value, isScrollDown = false) {
    this.TransportService.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.TransportService.dropdownList.length / 20) + 1;
    }
    this.orderService.GetSelect2TransportServiceData(value, pageNo).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.TransportService.dropdownList.length) {
        dropdownList = dropdownList.concat(this.TransportService.dropdownList);
        this.TransportService = { ...this.TransportService, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.TransportService = { ...this.TransportService, dropdownList: [...dropdownList] });
      this.TransportService.isSearch = false;
    }).catch(error => {
      this.TransportService.isSearch = false;
    })
  }

  GetVehicleType(value, isScrollDown = false) {
    this.VehicleType.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleType.dropdownList.length / 20) + 1;
    }
    this.orderService.GetVehicleTypeSelect2(value).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.VehicleType.dropdownList.length) {
        dropdownList = dropdownList.concat(this.VehicleType.dropdownList);
        this.VehicleType = { ...this.VehicleType, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.VehicleType = { ...this.VehicleType, dropdownList: [...dropdownList] });
      this.VehicleType.isSearch = false;
    }).catch(error => {
      this.VehicleType.isSearch = false;
    })
  }

  GetPickupLocationList(value, isScrollDown = false) {
    this.PickupLocation.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.PickupLocation.dropdownList.length / 20) + 1;
    }
    this.orderService.NewGetOriginDestination(value, 'Origin').then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.PickupLocation.dropdownList.length) {
        dropdownList = dropdownList.concat(this.PickupLocation.dropdownList);
        this.PickupLocation = { ...this.PickupLocation, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.PickupLocation = { ...this.PickupLocation, dropdownList: [...dropdownList] });
      this.PickupLocation.isSearch = false;
    }).catch(error => {
      this.PickupLocation.isSearch = false;
    })
  }

  GetDeliveryLocationList(value, isScrollDown = false) {
    this.DeliveryLocation.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.DeliveryLocation.dropdownList.length / 20) + 1;
    }
    this.orderService.NewGetOriginDestination(value, 'Destination').then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.DeliveryLocation.dropdownList.length) {
        dropdownList = dropdownList.concat(this.DeliveryLocation.dropdownList);
        this.DeliveryLocation = { ...this.DeliveryLocation, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.DeliveryLocation = { ...this.DeliveryLocation, dropdownList: [...dropdownList] });
      this.DeliveryLocation.isSearch = false;
    }).catch(error => {
      this.DeliveryLocation.isSearch = false;
    })
  }

  GetVehicleList(value, isScrollDown = false) {
    this.VehicleNo.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.VehicleNo.dropdownList.length / 20) + 1;
    }
    this.orderService.NewVehicleNoSelect2(value, pageNo).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.VehicleNo.dropdownList.length) {
        dropdownList = dropdownList.concat(this.VehicleNo.dropdownList);
        this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.VehicleNo = { ...this.VehicleNo, dropdownList: [...dropdownList] });
      this.VehicleNo.isSearch = false;
    }).catch(error => {
      this.VehicleNo.isSearch = false;
    })
  }

  GetDriverList(value, isScrollDown = false) {
    this.Driver.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Driver.dropdownList.length / 20) + 1;
    }
    this.orderService.GetDriverListFromOpRept(value, pageNo,this.TenantId).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Driver.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Driver.dropdownList);
        this.Driver = { ...this.Driver, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Driver = { ...this.Driver, dropdownList: [...dropdownList] });
      this.Driver.isSearch = false;
    }).catch(error => {
      this.Driver.isSearch = false;
    })
  }

  GetCustomerList(value, isScrollDown = false) {
    this.Customer.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Customer.dropdownList.length / 20) + 1;
    }
    this.orderService.SalesCustomerSelect2(value, pageNo,this.TenantId).then(res => {
      let dropdownList = [...res];
      if (isScrollDown && res.Total > this.Customer.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Customer.dropdownList);
        this.Customer = { ...this.Customer, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Customer = { ...this.Customer, dropdownList: [...dropdownList] });
      this.Customer.isSearch = false;
    }).catch(error => {
      this.Customer.isSearch = false;
    })
  }

  
  getChangedValue(value, data){
    const newValue = value && typeof value === 'object' && 'value' in value ? value.value : value;
    if(value){
      if(
          data.dataField === 'containerNumber'||
          data.dataField === 'tripDate'||
          data.dataField === 'sealNumbers' ||
          data.dataField === 'scanLines'
        )
      {
        this.data[data.dataField] = value;
      } else if(data.dataField === 'customer'){
        this.data[data.dataField] = value.value;
        this.data.customerName = value.name;
      } else if(data.dataField === 'truckNumber'){
        this.data[data.dataField] = value.value;
        this.data.VehicleNoText = value.name;
      } else if(data.dataField === 'size'){
        this.data[data.dataField] = value.value;
        this.data.sizeName = value.name;
      } else if(data.dataField === 'transportService'){
        this.data[data.dataField] = value.value;
        this.data.transportServiceName = value.name;
      } else if(data.dataField === 'Driver'){
        this.data[data.dataField] = value.value;
        this.data.driverId = value.value;
        this.data.driverName = value.name;
      } else if(data.dataField === 'dieselTaken' || data.dataField === 'weight'){
        this.data[data.dataField] = Number(value);
      } else{
        this.data[data.dataField] = value.value;
      }
    } else{
      if(
          data.dataField === 'containerNumber'||
          data.dataField === 'tripDate'||
          data.dataField === 'sealNumbers' ||
          data.dataField === 'scanLines'
        )
      {
        this.data[data.dataField] = null;
      } else if(data.dataField === 'customer'){
        this.data[data.dataField] = null;
        this.data.customerName = null;

      } else if(data.dataField === 'truckNumber'){
        this.data[data.dataField] = null;
        this.data.VehicleNoText = null;
      } else if(data.dataField === 'size'){
        this.data[data.dataField] = null;
        this.data.sizeName = null;
      } else if(data.dataField === 'transportService'){
        this.data[data.dataField] = null;
        this.data.transportServiceName = null;
      } else if(data.dataField === 'Driver'){
        this.data[data.dataField] = null;
        this.data.driverName = null;
        this.data.driverId = null;
      } else if(data.dataField === 'dieselTaken'){
        this.data[data.dataField] = 0;
      } else{
       this.data[data.dataField] = null;
      }
    }
  }

  Cancel() {
    this.onCloseBtnClick.emit()
  }

  Save(){
    this.isFormSubmitY=true;

    if(!this.data.containerNumber){
      this.toastr.warning('Please enter Container No','Warning');
      return;
    }
    if(!this.data.tripDate){
      this.toastr.warning('Please select trip date','Warning');
      return;
    }
    if(!this.data.customer){
      this.toastr.warning('Please select customer','Warning');
      return;
    }
    if(!this.data.origin){
      this.toastr.warning('Please select origin','Warning');
      return;
    }
    if(!this.data.destination){
      this.toastr.warning('Please select destination','Warning');
      return;
    }
    if(!this.data.truckNumber){
      this.toastr.warning('Please select vehicle number','Warning');
      return;
    }
    if(!this.data.size){
      this.toastr.warning('Please select vehicle size','Warning');
      return;
    }
    if(!this.data.transportService){
      this.toastr.warning('Please select transport service','Warning');
      return;
    }
    if(!this.data.weight){
      this.toastr.warning('Please enter weight','Warning');
      return;
    }

    const containerRegex = /^[A-Z]{3}U\d{7}$/;
    if (!this.data.containerNumber || !containerRegex.test(this.data.containerNumber)) {
      this.toastr.warning(`Invalid container number. Format should be like "XXXU0000000", “XXXU” Alpha and 7 digit number. Last “U” character must be there in container no`);
      return;
    }

    const vehicleRegex = /^[A-Z]{2}\d{2}[A-Z]{1,2}\d{4}$/;
    if (!this.data.VehicleNoText || !vehicleRegex.test(this.data.VehicleNoText)) {
      this.toastr.warning(`Invalid vehicle number. Format should be like "XX00AA0000" or "XX00A0000"`);
      return;
    }

    console.log('Save data:',this.data);

    const updatedData={
      IsUploadSuccess:this.data.IsUploadSuccess,
      Reason:this.data.Reason,
      headerName:this.data.Reason,
      isoCode:this.data.Reason,
      temp:this.data.temp,
      origin:this.data.origin,
      destination:this.data.destination,
      tripDate:this.data.tripDate,
      containerNumber:this.data.containerNumber,
      status:this.data.status,
      sealNumbers:this.data.sealNumbers,
      scanLines:this.data.scanLines,
      weight:this.data.weight,
      dieselTaken:this.data.dieselTaken,
      customer:this.data.customerName,
      size:this.data.sizeName,
      truckNumber:this.data.VehicleNoText,
      transportService:this.data.transportServiceName,
      driverId:this.data.driverId,
      driverName:this.data.driverName,
      eircopy:this.data.eircopy,
      singleLineText:this.data.singleLineText,
      SRNo:this.data.SRNo,
    } 
    
    console.log('Save data:',updatedData);

    this.sendDataToParent.emit(updatedData);
    this.Cancel();
  }

}
